import { render, staticRenderFns } from "./v-accordion.vue?vue&type=template&id=689c3439&scoped=true&"
import script from "./v-accordion.vue?vue&type=script&lang=js&"
export * from "./v-accordion.vue?vue&type=script&lang=js&"
import style0 from "./v-accordion.vue?vue&type=style&index=0&id=689c3439&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689c3439",
  null
  
)

export default component.exports